import React from 'react';

import { AddButton } from '../../../../components/Button';
import CommonDataGrid from '../../../../components/CommonDataGrid';
import { Column } from '../../../../components/CommonDataGrid/props';
import Loader from '../../../../components/Loader';
import DeleteImg from '../../../../images/SideBar/Delete';
import EditImg from '../../../../images/SideBar/Edit';
import ViewImg from '../../../../images/SideBar/View';
import { formatDate, style } from '../../../../util/constant';
import useEmployee from '../useEmployee';
import EditEmployeeIndex from './EditEmployee/index';
import ViewEmployeeIndex from './ViewEmployee/index';

const Employee: React.FC = () => {
  const {
    selectedEmployeeView,
    selectedEmployeeId,
    employeeData,
    showConfirmation,
    handleCancelStatusUp,
    updateScreen,
    handleConfirmStatusUp,
    handleView,
    handleEdit,
    handleAdd,
    handleStatusUp,
    handleDateFilter,
    setSearch,
    setPage,
    page,
    loading,
    totalPage,
  } = useEmployee();

  const columns: Column[] = [
    {
      field: "empId",
      headerName: "Employee ID",
      width: 50,
      align: "center",
    },
    {
      field: "name",
      headerName: "Employee Name",
      width: 50,
      align: "center",
    },
    { field: "email", headerName: "Employee Email", width: 50, align: "center" },
    {
      field: "doj",
      headerName: "Date of Joining",
      width: 50,
      align: "center",
      renderCell: (params: any) => (
        <p>{formatDate(params?.value)}</p>
      ),
    },
    {
      field: "department",
      headerName: "Department",
      width: 50,
      align: "center",
    },
    {
      field: "designation",
      headerName: "Designation",
      width: 50,
      align: "center",
    },
    {
      field: "status",
      renderCell: (params: any) => (
        <p className={`${style[params.value]}`}>{params.value}</p>
      ),
      headerName: "Status",
      width: 50,
      align: "center",
    },
    {
      field: "Actions",
      headerName: "Actions",
      width: 50,
      align: "center",
      renderCell: (params: any) => (
        <div className="flex space-x-2 justify-center">
          <button
            onClick={() => handleEdit(params.row.id)}
            className="text-fontColor hover:text-primary-2"
          >
            <EditImg />
          </button>
          <button
            onClick={() => handleStatusUp(params.row.id)}
            className="text-red-500 hover:text-red-700"
          >
            <DeleteImg />
          </button>
          <button
            onClick={() => handleView(params.row)}
            className="text-gray-500 hover:text-gray-700"
          >
            <ViewImg />
          </button>
        </div>
      ),
    },
  ];



  return (
    <div>
      <div className="m-5">
        {loading && <Loader />}
        <div>
          {selectedEmployeeView ? (
            <ViewEmployeeIndex
              employeeId={selectedEmployeeView}
              setMethod={() => updateScreen("view")}
            />
          ) : selectedEmployeeId ? (
            <EditEmployeeIndex
              employeeId={selectedEmployeeId}
              setMethod={() => updateScreen("edit")}
            />
          ) : (
            <>
              <div className="grid justify-items-end -mb-16 mr-5">
                <AddButton
                  onClick={handleAdd}
                  className="  "
                  children="+"
                  type="button"
                />
              </div>
              <CommonDataGrid
                tableName="Employee"
                rows={employeeData}
                columns={columns}
                getRowId={(row) => row._id}
                showConfirmation={showConfirmation}
                confirmationMessage="Are you sure you want to Status Update this Employee?"
                onCancelDelete={handleCancelStatusUp}
                onConfirmDelete={handleConfirmStatusUp}
                loading={!employeeData}
                onDateFilter={handleDateFilter}
                addButton
                setSearchBar={setSearch}
                setCurrentPage={setPage}
                currentPage={page}
                totalPages={totalPage}
                dayFilter={false}
              />
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Employee;
